import Card from "@/components/Card/index";
import ContentHeader from "@/components/ContentHeader";
import InfinityScrollList from "@/components/InfinityScrollList";
import Loading from "@/components/Loading";
import {
  useColumsInRow,
  useCopyrights,
  usePagination,
  useIntersectionObserver,
} from "@/hooks";
import styles from "@/styles/Grid.module.scss";
import chunk from "lodash/chunk";
import {
  memo,
  cloneElement,
  createElement,
  useEffect,
  useMemo,
  useRef,
} from "react";

export default function Grid({
  header,
  itemComponent = Card, // itemをレンダーするコンポーネント
  limit,
  maxLength,
  loadMore,
  loading, // useQueryの戻り値
  error, // useQueryの戻り値
  fetchMore, // useQueryの戻り値
  items,
  noContent,
  viewTypeClassName,
}) {
  if (error) {
    // TODO: error view
  }

  const columsInRow = useColumsInRow();
  const { setCopyrights } = useCopyrights();
  const { enableLoadMore, fetchMoreCallback } = usePagination({
    limit,
    maxLength,
    loadMore,
    fetchMore,
    items,
  });

  const dataLength = items?.data?.length || 0;
  const chunkedData = useMemo(() => {
    return chunk(items?.data, columsInRow);
  }, [dataLength, columsInRow, items]);

  useEffect(() => {
    if (items && items.data && items.data.length > 0) {
      const copyrights = items.data.map((item) => item.copyright);
      setCopyrights(copyrights);
    }
  }, [dataLength]);

  if (!loading && chunkedData.length === 0 && columsInRow) {
    if (noContent) {
      return <div className={styles.grid}>{cloneElement(noContent)}</div>;
    } else {
      return null;
    }
  }

  return (
    <div className={styles.grid}>
      {header && (
        <ContentHeader viewTypeClassName={viewTypeClassName} {...header} />
      )}
      {((loading && dataLength === 0) || !columsInRow) && (
        <Loading showStart={100} />
      )}
      <InfinityScrollList
        loadMore={enableLoadMore}
        fetchMore={fetchMoreCallback}
      >
        {chunkedData.map((data, i) => (
          <GridRow
            key={`grid-row-${i}`}
            row={i}
            rowData={data}
            itemComponent={itemComponent}
            columsInRow={columsInRow}
          />
        ))}
      </InfinityScrollList>
    </div>
  );
}

const GridRow = memo(({ rowData, row, itemComponent, columsInRow }) => {
  const rowRef = useRef();
  const intersect = useIntersectionObserver(rowRef, {
    root: null,
    rootMargin: "100px",
    threshold: 0.0,
  });
  return (
    <div className={styles.row} ref={rowRef}>
      {rowData.map((data, i) => (
        <div
          key={`grid-row-item-${row}-${i}`}
          className={styles.item}
          style={{ width: `${100 / columsInRow}%` }}
        >
          {createElement(itemComponent, {
            item: data,
            intersect,
          })}
        </div>
      ))}
    </div>
  );
});
